import type {representativeCommissionsRouteApi} from "./-route-api";

import {tableURLStateSchema} from "@project/components/data-display/table";
import {z} from "zod";

export const representativeCommissionsSearchSchema = tableURLStateSchema.extend({
  includeDeleted: z.boolean().optional().default(false),
});

export type RepresentativeCommissionsSearch = z.output<
  typeof representativeCommissionsSearchSchema
>;
export type RepresentativeCommissionsNavigateFn = ReturnType<
  typeof representativeCommissionsRouteApi.useNavigate
>;
